module.exports = __webpack_public_path__ + "static/zicara-f294e83f6e66d5338b6c73abb8dcec1c.png";